/* Study Hall campus apps: Bulletin Board (board), Yearbook (yearbook), Honor Roll (honor)
   and the Store hall-pass reminder. Uses the window.SHX kit from sh-campus.js; every kit
   call is guarded so a missing piece degrades quietly instead of throwing.
   All user text is escaped. Nothing private is stored in the browser: the reminder keeps
   only a seconds counter and a mute flag in localStorage. */
(function () {
  'use strict';

  // ── Pure helpers (unit-tested in node) ──
  var H = {};
  H.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  H.text = function (s) { return H.esc(String(s == null ? '' : s).replace(/\r\n?/g, '\n').replace(/\n{3,}/g, '\n\n').trim()).replace(/\n/g, '<br>'); };
  H.pad3 = function (n) { n = Math.max(0, Math.floor(Number(n) || 0)); return n < 1000 ? ('00' + n).slice(-3) : String(n); };
  H.num = function (n) { n = Math.round(Number(n) || 0); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  H.norm = function (r) {
    if (r && typeof r === 'object' && typeof r.ok === 'boolean' && Object.prototype.hasOwnProperty.call(r, 'data')) return { ok: r.ok, status: r.status || 0, data: r.data || {} };
    if (!r || typeof r !== 'object') return { ok: false, status: 0, data: {} };
    return { ok: !r.error, status: r.error ? 400 : 200, data: r };
  };
  H.page = function (list, page, per) {
    list = list || []; per = per || 20;
    var pages = Math.max(1, Math.ceil(list.length / per));
    var p = Math.min(Math.max(1, Math.floor(Number(page) || 1)), pages);
    return { items: list.slice((p - 1) * per, p * per), page: p, pages: pages, total: list.length };
  };
  H.namesOf = function (s) {
    if (!s) return [];
    var a = s.artists || s.guests || s.artist;
    if (typeof a === 'string' && a.trim()) return [a.trim()];
    if (Array.isArray(a)) {
      var out = a.map(function (x) { return typeof x === 'string' ? x : x && (x.name || x.display_name || x.title); })
        .filter(function (x) { return typeof x === 'string' && x.trim(); }).map(function (x) { return x.trim(); });
      if (out.length) return out;
    }
    var t = String(s.title || '');
    var i = t.indexOf(':');
    var n = (i >= 0 ? t.slice(i + 1) : t).trim();
    return n ? [n] : [];
  };
  H.cityOf = function (s) {
    if (!s) return '';
    var c = s.city || s.cities;
    if (typeof c === 'string') return c.trim();
    if (Array.isArray(c)) return c.map(function (x) { return typeof x === 'string' ? x : x && (x.name || x.title); }).filter(Boolean).join(' · ');
    if (c && typeof c === 'object') return String(c.name || c.title || '');
    return '';
  };
  H.ytOf = function (s) {
    var y = s && (s.youtube || s.youtube_id || s.youtubeId || s.yt);
    return typeof y === 'string' && /^[A-Za-z0-9_-]{6,20}$/.test(y) ? y : '';
  };
  H.notesOf = function (s) {
    var u = s && (s.url || s.fieldNotes || s.field_notes || s.field_notes_url || s.notesUrl);
    if (u && typeof u === 'object') u = u.url;
    return typeof u === 'string' && /^(\/|https:\/\/)/.test(u) ? u : '';
  };
  H.productIdsOf = function (s) {
    var a = s && (s.products || s.objects || s.product_ids || s.productIds);
    if (!Array.isArray(a)) return [];
    var out = [];
    a.forEach(function (x) {
      var v = x && typeof x === 'object' ? (x.id != null ? x.id : x.gid) : x;
      var m = String(v == null ? '' : v).match(/(\d{4,20})$/);
      if (m && out.indexOf(Number(m[1])) === -1) out.push(Number(m[1]));
    });
    return out;
  };
  H.articleKey = function (s) { return '/yearbook/study-' + H.pad3(s && s.number); };
  // Yearbook pages: cover, contents, one spread per study (or per artist when the data lists them), records, back cover
  H.ybPages = function (studies) {
    var list = (studies || []).filter(function (s) { return s && (s.title || s.number); }).slice().sort(function (a, b) { return (Number(a.number) || 0) - (Number(b.number) || 0); });
    var pages = [{ k: 'cover' }, { k: 'toc' }];
    list.forEach(function (s) {
      var structured = Array.isArray(s.artists) && H.namesOf({ artists: s.artists }).length > 1;
      var names = H.namesOf(s);
      if (structured) names.forEach(function (n) { pages.push({ k: 'study', s: s, names: [n], all: names }); });
      else pages.push({ k: 'study', s: s, names: names, all: names });
    });
    if (list.length) pages.push({ k: 'records' });
    pages.push({ k: 'back' });
    return pages;
  };
  // Playful "class records" worked out only from the yearbook's own data
  H.records = function (studies, products) {
    var list = (studies || []).filter(function (s) { return s && s.number; }).slice().sort(function (a, b) { return a.number - b.number; });
    var out = [];
    if (!list.length) return out;
    out.push({ t: 'First class to enroll', v: 'Study ' + H.pad3(list[0].number), s: list[0] });
    if (list.length > 1) out.push({ t: 'Newest class', v: 'Study ' + H.pad3(list[list.length - 1].number), s: list[list.length - 1] });
    var big = null; list.forEach(function (s) { var n = (H.namesOf(s)[0] || '').split(/\s*(?:&|,| and )\s*/).length; if (n > 1 && (!big || n > big.n)) big = { n: n, s: s }; });
    if (big) out.push({ t: 'Biggest group photo', v: 'Study ' + H.pad3(big.s.number), s: big.s });
    var ids = {}; (products || []).forEach(function (p) { ids[p.id] = 1; });
    var most = null; list.forEach(function (s) { var n = H.productIdsOf(s).filter(function (i) { return ids[i]; }).length; if (n && (!most || n > most.n)) most = { n: n, s: s }; });
    if (most) out.push({ t: 'Most objects in the Store', v: 'Study ' + H.pad3(most.s.number) + ' (' + most.n + ')', s: most.s });
    out.push({ t: 'Perfect attendance', v: list.length + ' ' + (list.length === 1 ? 'study' : 'studies') + ' so far' });
    return out;
  };
  H.shortLabel = function (l) { return String(l || '').replace(/\s*\(.*\)\s*$/, '').trim() || String(l || ''); };
  H.unitOf = function (l) { var m = String(l || '').match(/\(([^)]*)\)\s*$/); return m ? m[1] : ''; };
  H.scoreFmt = function (label, v) {
    var u = H.unitOf(label);
    if (/\$/.test(u)) return '$' + H.num(v);
    if (/wpm/i.test(u)) return H.num(v) + ' wpm';
    return H.num(v);
  };
  // Store reminder clock. e = seconds on the site with the tab visible (kept across page
  // loads and tabs), next = the e at which the next popup is due, seen = last tick (ms).
  // A visit ends after 30 idle minutes; then the clock and the mute start fresh.
  H.REMIND_EVERY = 300;
  H.TEST_FIRST = 10;
  H.VISIT_GAP = 1800;
  H.remState = function (raw, now, test) {
    var st = raw && typeof raw === 'object' ? raw : null;
    if (!st || !(now - (+st.seen || 0) <= H.VISIT_GAP * 1000)) st = { e: 0, next: H.REMIND_EVERY, mute: false, seen: now };
    var out = { e: Math.max(0, +st.e || 0), next: +st.next, mute: !!st.mute, seen: +st.seen || now };
    if (!isFinite(out.next) || out.next <= 0) out.next = out.e + H.REMIND_EVERY;
    if (test) out.next = Math.min(out.next, out.e + H.TEST_FIRST);
    return out;
  };
  H.tick = function (st, visible, now) { return { e: (st.e || 0) + (visible ? 1 : 0), next: st.next, mute: !!st.mute, seen: now }; };
  H.due = function (st, blocked, showing) { return !!st && !st.mute && !blocked && !showing && st.e >= st.next; };
  H.later = function (st) { st.next = st.e + H.REMIND_EVERY; return st; };
  H.LINES = [
    'Hall pass check: the Study Hall Store is open.',
    'Between classes? The Study Hall Store is open.',
    'The bell hasn’t rung yet. Plenty of time to visit the Store.',
    'Field trip idea: the Study Hall Store, no permission slip needed.',
    'Locker looking empty? The Study Hall Store is open.',
    'Professor G says: the Store is open during study period.'
  ];

  if (typeof module === 'object' && module && module.exports) { module.exports = H; return; }

  // ── Kit wrapper ──
  var S = null, D = {}, I = {};
  function esc(s) { try { if (S && typeof S.esc === 'function') return S.esc(s); } catch (e) {} return H.esc(s); }
  function $(id) { return document.getElementById(id); }
  function rawApi(path, opts) {
    opts = opts || {};
    if (!D.api || !window.fetch) return Promise.resolve({ ok: false, status: 0, data: {} });
    var h = { 'content-type': 'application/json' };
    if (D.token) h['x-sh-token'] = D.token;
    var method = opts.method || (opts.body ? 'POST' : 'GET');
    return fetch(D.api + path, { method: method, headers: h, body: method === 'GET' ? undefined : JSON.stringify(opts.body || {}) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, data: j }; }); });
  }
  function api(path, opts) {
    return new Promise(function (res) {
      var p;
      try { p = S && typeof S.api === 'function' ? S.api(path, opts || {}) : rawApi(path, opts); } catch (e) { res({ ok: false, status: 0, data: {} }); return; }
      Promise.resolve(p).then(function (r) { res(H.norm(r)); }, function (err) {
        var d = err && typeof err === 'object' ? (err.data || (err.error ? { error: err.error } : {})) : {};
        res({ ok: false, status: (err && err.status) || 0, data: d || {} });
      });
    });
  }
  function signedIn() { try { if (S && typeof S.signedIn === 'function') return !!S.signedIn(); } catch (e) {} return !!D.token; }
  function me() { try { if (S && typeof S.me === 'function') return S.me() || null; } catch (e) {} return null; }
  function openProfile(h) {
    if (!h) return;
    try { if (S && typeof S.openProfile === 'function') { S.openProfile(h); return; } } catch (e) {}
    try { if (typeof window.shxProfile === 'function') window.shxProfile(h); } catch (e) {}
  }
  function openApp(id) { try { if (S && typeof S.openApp === 'function') S.openApp(id); } catch (e) {} }
  function fmtDate(iso) {
    try { if (S && typeof S.fmtDate === 'function') { var r = S.fmtDate(iso); if (r) return String(r); } } catch (e) {}
    var d = new Date(iso); if (!iso || isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function sget(k, d) { try { if (S && S.store && typeof S.store.get === 'function') return S.store.get(k, d); } catch (e) {} return d; }
  function sset(k, v) { try { if (S && S.store && typeof S.store.set === 'function') S.store.set(k, v); } catch (e) {} }
  var FALLBACK_COLORS = ['#6c5873', '#474934', '#faa722', '#f79b87', '#991f34', '#137590', '#e16436', '#7c8041'];
  function avatar(p, size) {
    size = size || 32;
    try { if (S && typeof S.avatarHTML === 'function') { var h = S.avatarHTML(p, size); if (typeof h === 'string' && h) return h; } } catch (e) {}
    var name = (p && (p.display_name || p.handle)) || '?';
    var c = (p && p.portrait && /^#[0-9a-f]{3,8}$/i.test(p.portrait.color || '')) ? p.portrait.color : FALLBACK_COLORS[name.length % 8];
    return '<span class="sha-av-fb" style="width:' + size + 'px;height:' + size + 'px;background:' + c + ';font-size:' + Math.round(size / 2.2) + 'px">' + esc(name.charAt(0).toUpperCase()) + '</span>';
  }
  function isPhone() { try { return window.matchMedia('(max-width: 640px)').matches; } catch (e) { return false; } }
  function shown(el) { return !!(el && el.getClientRects && el.getClientRects().length); }
  function signInUrl() { return D.loginUrl || '/account/login'; }
  function portal() { try { if (typeof window.shxPortal === 'function') { window.shxPortal('profile'); return; } } catch (e) {} openApp('card'); }
  function errText(r, fallback) {
    var e = r && r.data && r.data.error;
    return e === 'slow_down' ? 'Slow down a little, then try again.' : e === 'staff_only' ? 'Only the Front Office can start threads here.' :
      e === 'locked' ? 'This thread is locked.' : e === 'sign_in' ? 'Your sign-in expired. Reload the page.' :
      e === 'hidden' ? 'Your Yearbook page is hidden right now.' : e === 'make_profile' ? 'Publish your Yearbook page first, so classmates know who’s talking.' : (fallback || 'Couldn’t do that right now.');
  }
  function needPage(r) { return r && r.data && r.data.error === 'make_profile'; }
  function band(title, sub) {
    return '<div class="shx-band">' + (I.arch ? '<img class="arch" src="' + esc(I.arch) + '" alt="Study Hall">' : '') + '<div><b>' + esc(title) + '</b>' + (sub ? '<div class="sub">' + esc(sub) + '</div>' : '') + '</div></div>';
  }
  function signInNote(what) {
    return '<div class="sha-note">' + esc(what) + ' <a class="shx-btn" href="' + esc(signInUrl()) + '">Sign in</a>' +
      (D.registerUrl ? ' <a class="shx-btn" href="' + esc(D.registerUrl) + '">Enroll</a>' : '') + '</div>';
  }
  function pageNote() { return '<div class="sha-note">Publish your Yearbook page first, so classmates know who’s talking. <button type="button" class="shx-btn" data-sha="portal">Make my page</button></div>'; }
  function pager(pg, attr) {
    if (pg.pages <= 1) return '';
    var h = '<div class="sha-pager"><span>Page</span>';
    for (var i = 1; i <= pg.pages; i++) h += '<button type="button" class="shx-btn" ' + attr + '="' + i + '" aria-pressed="' + (i === pg.page) + '">' + i + '</button>';
    return h + '</div>';
  }
  function authorHTML(a, size) {
    a = a || {};
    var name = a.display_name || a.handle || 'Classmate';
    return a.handle ? '<button type="button" class="sha-name" data-sha-profile="' + esc(a.handle) + '">' + esc(name) + '</button>' : '<b>' + esc(name) + '</b>';
  }
  function levelOf(a) { return a && (a.level || a.rank || a.loyalty || a.loyalty_level) || ''; }
  // One delegated click handler per app body
  function wire(body, fn) {
    if (body.__shaWired) { body.__shaFn = fn; return; }
    body.__shaWired = true; body.__shaFn = fn;
    body.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null; if (!t) return;
      var pf = t.closest('[data-sha-profile]');
      if (pf) { e.preventDefault(); openProfile(pf.getAttribute('data-sha-profile')); return; }
      if (t.closest('[data-sha="portal"]')) { e.preventDefault(); portal(); return; }
      try { body.__shaFn(e, t); } catch (err) { if (window.console) console.error(err); }
    });
  }

  // ══ 1. Bulletin Board ══
  var B = { view: 'cats', cat: null, tid: null, tpage: 1, ppage: 1, cats: null, threads: {}, thread: null, msg: '', busy: false, body: null };
  var T_PER = 20, P_PER = 15;
  function catById(id) { return (B.cats || []).filter(function (c) { return c.id === id; })[0] || null; }
  function canStart(c) { var m = me(); return !!c && (!c.staffOnly || !!(m && m.is_staff)); }
  function bRender() {
    var body = B.body; if (!body) return;
    var h = band('Bulletin Board', 'Study Hall University message board');
    var crumbs = ['<button type="button" class="sha-crumb" data-bb="home">Bulletin Board</button>'];
    var c = catById(B.cat);
    if (B.view !== 'cats' && c) crumbs.push('<button type="button" class="sha-crumb" data-bb="cat" data-id="' + esc(c.id) + '">' + esc(c.name) + '</button>');
    if (B.view === 'thread' && B.thread) crumbs.push('<span>' + esc(B.thread.title) + '</span>');
    if (B.view === 'new') crumbs.push('<span>New thread</span>');
    h += '<div class="sha-bar shx-raised"><div class="sha-crumbs">' + crumbs.join('<i>›</i>') + '</div>' + (B.view === 'threads' && canStart(c) && signedIn() ? '<button type="button" class="shx-btn shx-btn-blue" data-bb="new">New thread</button>' : '') + '</div>';
    h += '<div class="sha-scroll shx-sunken sha-bb">';
    if (B.msg) h += '<div class="sha-note" role="status">' + esc(B.msg) + '</div>';
    if (B.view === 'cats') h += bCats();
    else if (B.view === 'threads') h += bThreads();
    else if (B.view === 'thread') h += bThread();
    else if (B.view === 'new') h += bNew();
    h += '</div>';
    body.innerHTML = h;
    var sc = body.querySelector('.sha-scroll'); if (sc && B.scrollTop) { sc.scrollTop = 0; B.scrollTop = false; }
    bForms();
  }
  function bCats() {
    if (!B.cats) return '<div class="shx-empty">Loading the board…</div>';
    if (!B.cats.length) return '<div class="shx-empty">The Bulletin Board is offline right now.</div>';
    var h = '<table class="sha-tbl"><thead><tr><th>Forum</th><th class="n">Threads</th><th class="n">Posts</th><th class="l">Last post</th></tr></thead><tbody>';
    B.cats.forEach(function (c) {
      h += '<tr><td><button type="button" class="sha-tl" data-bb="cat" data-id="' + esc(c.id) + '">' + esc(c.name) + '</button>' + (c.staffOnly ? ' <span class="sha-tag">Front Office posts</span>' : '') +
        '<div class="shx-fine">' + esc(c.about || '') + '</div><div class="sha-mob shx-fine">' + H.num(c.threads) + ' threads · ' + H.num(c.posts) + ' posts' + (c.last ? ' · last ' + esc(fmtDate(c.last)) : '') + '</div></td>' +
        '<td class="n">' + H.num(c.threads) + '</td><td class="n">' + H.num(c.posts) + '</td><td class="l">' + (c.last ? esc(fmtDate(c.last)) : '—') + '</td></tr>';
    });
    h += '</tbody></table>';
    if (!signedIn()) h += signInNote('Members can start threads and reply.');
    return h;
  }
  function bThreads() {
    var c = catById(B.cat), list = B.threads[B.cat];
    var h = c ? '<div class="sha-cathead"><b>' + esc(c.name) + '</b><span class="shx-fine">' + esc(c.about || '') + '</span></div>' : '';
    if (!list) return h + '<div class="shx-empty">Loading threads…</div>';
    if (list.error) return h + '<div class="shx-empty">Threads are offline right now.</div>';
    if (!list.length) return h + '<div class="shx-empty">No threads yet.' + (canStart(c) && signedIn() ? ' Start the first one.' : '') + '</div>' + (signedIn() ? '' : signInNote('Members can start threads.'));
    var sorted = list.slice().sort(function (a, b) { return (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0) || String(b.last_post_at || '').localeCompare(String(a.last_post_at || '')); });
    var pg = H.page(sorted, B.tpage, T_PER); B.tpage = pg.page;
    h += '<table class="sha-tbl"><thead><tr><th>Thread</th><th class="n">Replies</th><th class="l">Last post</th></tr></thead><tbody>';
    pg.items.forEach(function (t) {
      h += '<tr' + (t.pinned ? ' class="sha-pin"' : '') + '><td>' + (t.pinned ? '<span class="sha-tag sha-tag-pin">Pinned</span> ' : '') + (t.locked ? '<span class="sha-tag">Locked</span> ' : '') +
        '<button type="button" class="sha-tl" data-bb="thread" data-id="' + esc(t.id) + '">' + esc(t.title) + '</button><div class="shx-fine">by ' + authorHTML(t.author) + ' · ' + esc(fmtDate(t.created_at)) +
        '<span class="sha-mob"> · ' + H.num(t.reply_count) + ' replies</span></div></td><td class="n">' + H.num(t.reply_count) + '</td><td class="l">' + esc(fmtDate(t.last_post_at || t.created_at)) + '</td></tr>';
    });
    h += '</tbody></table>' + pager(pg, 'data-bb-tp');
    if (!signedIn()) h += signInNote('Members can start threads and reply.');
    return h;
  }
  function postHTML(p, kind) {
    var a = p.author || {}, lvl = levelOf(a);
    return '<article class="sha-post"><div class="sha-post-a">' + (a.handle ? '<button type="button" class="sha-av" data-sha-profile="' + esc(a.handle) + '" aria-label="' + esc(a.display_name || a.handle) + '">' + avatar(a, 48) + '</button>' : avatar(a, 48)) +
      '<div class="sha-post-who">' + authorHTML(a) + (a.handle ? '<small>@' + esc(a.handle) + '</small>' : '') +
      (a.is_official ? '<span class="sha-tag sha-tag-pin">Official</span>' : a.is_staff ? '<span class="sha-tag sha-tag-pin">Staff</span>' : '') +
      (lvl ? '<span class="sha-tag">' + esc(lvl) + '</span>' : '') + '</div></div>' +
      '<div class="sha-post-b"><div class="sha-post-top"><span class="shx-fine">' + esc(fmtDate(p.created_at)) + '</span>' +
      (signedIn() ? '<button type="button" class="sha-link" data-bb="report" data-kind="' + kind + '" data-id="' + esc(p.id) + '">Report</button>' : '') + '</div>' +
      '<div class="sha-post-t">' + H.text(p.body) + '</div></div></article>';
  }
  function bThread() {
    var t = B.thread;
    if (!t) return '<div class="shx-empty">Loading thread…</div>';
    if (t.error) return '<div class="shx-empty">That thread isn’t available.</div>';
    var all = [{ id: t.id, body: t.body, created_at: t.created_at, author: t.author, _op: true }].concat(t.posts || []);
    var pg = H.page(all, B.ppage, P_PER); B.ppage = pg.page;
    var h = '<div class="sha-thead"><b>' + esc(t.title) + '</b>' + (t.locked ? ' <span class="sha-tag">Locked</span>' : '') + '<span class="shx-fine">' + H.num((t.posts || []).length) + ' replies</span></div>';
    h += pager(pg, 'data-bb-pp');
    pg.items.forEach(function (p) { h += postHTML(p, p._op ? 'thread' : 'post'); });
    h += pager(pg, 'data-bb-pp');
    if (t.locked) h += '<div class="sha-note">This thread is locked.</div>';
    else if (!signedIn()) h += signInNote('Sign in to reply.');
    else h += '<form class="sha-form" data-bb-form="reply"><label class="shx-fine" for="sha-bb-reply">Reply</label><textarea id="sha-bb-reply" class="shx-field" rows="4" maxlength="4000" required placeholder="Write a reply…"></textarea><div class="sha-form-row"><button type="submit" class="shx-btn shx-btn-blue">Post reply</button><span class="shx-fine" role="status"></span></div></form>';
    return h;
  }
  function bNew() {
    if (!signedIn()) return signInNote('Sign in to start a thread.');
    var cats = (B.cats || []).filter(canStart);
    var h = '<form class="sha-form" data-bb-form="thread"><label class="shx-fine">Forum<select class="shx-field" name="cat">' +
      cats.map(function (c) { return '<option value="' + esc(c.id) + '"' + (c.id === B.cat ? ' selected' : '') + '>' + esc(c.name) + '</option>'; }).join('') + '</select></label>' +
      '<label class="shx-fine">Title<input class="shx-field" name="title" maxlength="120" required></label>' +
      '<label class="shx-fine">Message<textarea class="shx-field" name="body" rows="8" maxlength="4000" required></textarea></label>' +
      '<p class="shx-fine" style="margin:0">Be kind. Posts can be reported, and three reports send a post back to the Front Office.</p>' +
      '<div class="sha-form-row"><button type="submit" class="shx-btn shx-btn-blue">Post thread</button><button type="button" class="shx-btn" data-bb="cat" data-id="' + esc(B.cat || '') + '">Cancel</button><span class="shx-fine" role="status"></span></div></form>';
    return h;
  }
  function bForms() {
    var body = B.body; if (!body) return;
    Array.prototype.forEach.call(body.querySelectorAll('form[data-bb-form]'), function (f) {
      f.onsubmit = function (ev) {
        ev.preventDefault(); if (B.busy) return;
        var st = f.querySelector('[role=status]'), kind = f.getAttribute('data-bb-form');
        var req;
        if (kind === 'reply') {
          var tx = f.querySelector('textarea').value.trim(); if (!tx || !B.thread) return;
          req = api('/forum/post', { method: 'POST', body: { thread: B.thread.id, body: tx } });
        } else {
          var cat = f.elements.cat && f.elements.cat.value, ti = f.elements.title.value.trim(), bo = f.elements.body.value.trim();
          if (!cat || !ti || !bo) return;
          req = api('/forum/thread', { method: 'POST', body: { category: cat, title: ti, body: bo } });
        }
        B.busy = true; if (st) st.textContent = 'Posting…';
        req.then(function (r) {
          B.busy = false;
          if (!r.ok) { if (needPage(r)) { f.insertAdjacentHTML('afterend', pageNote()); if (st) st.textContent = ''; } else if (st) st.textContent = errText(r, 'Couldn’t post right now.'); return; }
          var pending = r.data && r.data.status === 'pending';
          if (kind === 'reply') {
            B.msg = pending ? 'Reply sent to the Front Office for review.' : '';
            loadThread(B.thread.id, true);
          } else {
            var cat2 = f.elements.cat.value; delete B.threads[cat2]; B.cat = cat2; loadCats();
            if (pending || !r.data || !r.data.id) { B.msg = pending ? 'Thread sent to the Front Office for review.' : 'Posted.'; B.view = 'threads'; loadThreads(cat2); }
            else { B.msg = ''; B.view = 'thread'; loadThread(r.data.id); }
          }
        });
      };
    });
  }
  function loadCats() { api('/forum').then(function (r) { B.cats = r.ok && Array.isArray(r.data.categories) ? r.data.categories : []; bRender(); }); }
  function loadThreads(cat) {
    api('/forum/threads?cat=' + encodeURIComponent(cat)).then(function (r) {
      B.threads[cat] = r.ok && Array.isArray(r.data.threads) ? r.data.threads : { error: true };
      if (B.cat === cat && B.view === 'threads') bRender();
    });
  }
  function loadThread(id, toEnd) {
    if (!toEnd) { B.thread = null; B.ppage = 1; }
    bRender();
    api('/forum/thread?id=' + encodeURIComponent(id)).then(function (r) {
      if (B.view !== 'thread') return;
      B.thread = r.ok && r.data.thread ? Object.assign({}, r.data.thread, { posts: r.data.posts || [] }) : { error: true };
      if (r.ok && r.data.thread && !B.cat) B.cat = r.data.thread.category;
      if (toEnd && !B.thread.error) B.ppage = Math.ceil((B.thread.posts.length + 1) / P_PER);
      bRender();
      if (toEnd) { var sc = B.body && B.body.querySelector('.sha-scroll'); if (sc) sc.scrollTop = sc.scrollHeight; }
    });
  }
  function bClick(e, t) {
    var tp = t.closest('[data-bb-tp]'); if (tp) { B.tpage = +tp.getAttribute('data-bb-tp'); B.scrollTop = true; bRender(); return; }
    var pp = t.closest('[data-bb-pp]'); if (pp) { B.ppage = +pp.getAttribute('data-bb-pp'); B.scrollTop = true; bRender(); return; }
    var b = t.closest('[data-bb]'); if (!b) return;
    var a = b.getAttribute('data-bb'), id = b.getAttribute('data-id');
    if (a !== 'report') B.msg = '';
    if (a === 'home') { B.view = 'cats'; loadCats(); bRender(); }
    else if (a === 'cat') { if (!id) { B.view = 'cats'; bRender(); return; } B.view = 'threads'; B.cat = id; B.tpage = 1; B.scrollTop = true; bRender(); loadThreads(id); }
    else if (a === 'thread') { B.view = 'thread'; B.tid = id; B.scrollTop = true; loadThread(id); }
    else if (a === 'new') { B.view = 'new'; bRender(); }
    else if (a === 'report') {
      b.disabled = true; b.textContent = 'Reporting…';
      api('/forum/report', { method: 'POST', body: { kind: b.getAttribute('data-kind'), id: Number(id) } }).then(function (r) { b.textContent = r.ok ? 'Reported. Thanks.' : 'Couldn’t report'; });
    }
  }
  function renderBoard(body) {
    B.body = body; wire(body, bClick);
    if (!B.cats) loadCats();
    else if (B.view === 'cats') loadCats();
    bRender();
  }

  // ══ 2. Yearbook ══
  var Y = { i: 0, pages: [], body: null, sig: {}, dir: '' };
  function ybStudies() { return Array.isArray(D.studies) ? D.studies : []; }
  function productsFor(s) {
    var ids = H.productIdsOf(s), all = Array.isArray(D.products) ? D.products : [];
    var own = Array.isArray(s && s.objects) ? s.objects : [];
    return ids.map(function (id) {
      return all.filter(function (p) { return Number(p.id) === id; })[0] ||
        own.filter(function (o) { return o && typeof o === 'object' && Number(o.id) === id && o.title && o.url; })[0];
    }).filter(Boolean);
  }
  function ybFoot(n) { return '<div class="sha-yb-pno">' + n + '</div>'; }
  function ybCover() {
    var n = ybStudies().length;
    return '<div class="sha-yb-cover"><div class="sha-yb-emboss">' + (I.crest ? '<img src="' + esc(I.crest) + '" alt="">' : '') +
      '<div class="sha-yb-c1">Study Hall University</div><div class="sha-yb-c2">Yearbook</div><div class="sha-yb-c3">' + (n ? n + ' ' + (n === 1 ? 'class' : 'classes') + ' · every artist we’ve studied with' : 'Every artist we’ve studied with') + '</div></div>' +
      '<button type="button" class="shx-btn shx-btn-blue" data-yb="next">Open the yearbook ▶</button></div>';
  }
  function ybToc() {
    var h = '<div class="sha-yb-spread"><div class="sha-yb-page"><h2 class="sha-yb-h">Class Directory</h2><ol class="sha-yb-toc">';
    Y.pages.forEach(function (p, i) {
      if (p.k === 'study') h += '<li><button type="button" data-yb-go="' + i + '"><span>Study ' + esc(H.pad3(p.s.number)) + ' · ' + esc(p.names.join(', ') || p.s.title) + '</span><i></i><b>' + (i + 1) + '</b></button></li>';
      else if (p.k === 'records') h += '<li><button type="button" data-yb-go="' + i + '"><span>Class Records</span><i></i><b>' + (i + 1) + '</b></button></li>';
    });
    h += '</ol>' + (ybStudies().length ? '' : '<p class="shx-fine">The class list is on its way.</p>') + ybFoot(Y.i + 1) + '</div>' +
      '<div class="sha-yb-page sha-yb-side"><h2 class="sha-yb-h">How to use this yearbook</h2><p>Every Study Hall episode gets a page: the artists, the episode, the Field Notes and anything from the study that’s in the Store.</p>' +
      '<p>Members can sign each page, like the last day of school. Keep it kind.</p>' + (I.giuseppeHead ? '<img class="sha-yb-g" src="' + esc(I.giuseppeHead) + '" alt="Professor G">' : '') + '</div></div>';
    return h;
  }
  function ybStudy(p) {
    var s = p.s, yt = H.ytOf(s), notes = H.notesOf(s), city = H.cityOf(s), objs = productsFor(s), num = H.pad3(s.number);
    var name = p.names.join(', ') || s.title || ('Study ' + num);
    var h = '<div class="sha-yb-spread"><div class="sha-yb-page sha-yb-photo-page">' +
      '<div class="sha-yb-photo">' + (yt ? '<img src="https://i.ytimg.com/vi/' + esc(yt) + '/hqdefault.jpg" alt="' + esc(name) + ', from Study ' + esc(num) + '" loading="lazy">' : '<div class="sha-yb-nophoto">Photo day pending</div>') + '</div>' +
      '<div class="sha-yb-cap"><b>' + esc(name) + '</b><span>Class of Study ' + esc(num) + '</span></div>' + ybFoot(Y.i + 1) + '</div>' +
      '<div class="sha-yb-page"><div class="sha-yb-name">' + esc(name) + '</div>' +
      (p.all.length > 1 && p.names.length === 1 ? '<div class="shx-fine">Classmates: ' + esc(p.all.filter(function (x) { return x !== p.names[0]; }).join(', ')) + '</div>' : '') +
      '<dl class="sha-yb-facts"><dt>Class of</dt><dd>Study ' + esc(num) + '</dd>' + (city ? '<dt>City</dt><dd>' + esc(city) + '</dd>' : '') + (s.title ? '<dt>Episode</dt><dd>' + esc(s.title) + '</dd>' : '') + '</dl>' +
      '<div class="sha-yb-sh">Seen in</div><div class="sha-yb-seen">' +
      (yt ? '<button type="button" class="shx-btn" data-yb="watch" data-yt="' + esc(yt) + '">▶ Watch the episode</button>' : '') +
      (notes ? '<a class="shx-btn" href="' + esc(notes) + '" data-shx-url="' + esc(notes) + '">Read the Field Notes</a>' : '') + '</div>' +
      (objs.length ? '<div class="sha-yb-objs">' + objs.slice(0, 4).map(function (o) { return '<a href="' + esc(o.url || '#') + '" data-shx-product="' + esc(o.id) + '" class="sha-yb-obj">' + (o.image ? '<img src="' + esc(o.image) + '" alt="" loading="lazy">' : '') + '<span><b>' + esc(o.title) + '</b>' + (o.price ? '<small>' + esc(o.price) + '</small>' : '') + '<em>Shop the object</em></span></a>'; }).join('') + '</div>' : '') +
      (!yt && !notes && !objs.length ? '<p class="shx-fine">More coming soon.</p>' : '') +
      '<div class="sha-yb-sh">Signatures</div><div class="sha-yb-sigs" data-yb-sigs="' + esc(H.articleKey(s)) + '">' + ybSigs(H.articleKey(s), name) + '</div></div></div>';
    return h;
  }
  function ybSigs(key, name) {
    var d = Y.sig[key], h = '';
    if (!d) { loadSigs(key); h += '<p class="shx-fine">Loading signatures…</p>'; }
    else if (d.error) h += '<p class="shx-fine">Signatures are offline right now.</p>';
    else if (!d.list.length) h += '<p class="shx-fine">Nobody has signed this page yet.</p>';
    else h += '<ul class="sha-sig-list">' + d.list.map(function (c, i) { var a = c.author || {}; return '<li class="sha-sig sha-sig-' + (i % 4) + '"><span>' + H.text(c.body) + '</span><small>– ' + authorHTML(a) + (c.created_at ? ', ' + esc(fmtDate(c.created_at)) : '') + '</small></li>'; }).join('') + '</ul>';
    if (!signedIn()) h += '<p class="shx-fine"><a href="' + esc(signInUrl()) + '">Sign in</a> to sign this page.</p>';
    else h += '<form class="sha-form sha-sig-form" data-yb-sign="' + esc(key) + '"><label class="shx-sr" for="sha-sig-' + esc(key.replace(/\W/g, '')) + '">Sign the page</label><textarea id="sha-sig-' + esc(key.replace(/\W/g, '')) + '" class="shx-field" rows="2" maxlength="200" required placeholder="Sign ' + esc(name) + '’s page…"></textarea><div class="sha-form-row"><button type="submit" class="shx-btn shx-btn-blue">Sign</button><span class="shx-fine" role="status"></span></div></form>';
    return h;
  }
  var sigLoading = {};
  function loadSigs(key) {
    if (sigLoading[key]) return;
    sigLoading[key] = true;
    api('/comments?article=' + encodeURIComponent(key)).then(function (r) {
      sigLoading[key] = false;
      Y.sig[key] = r.ok ? { list: Array.isArray(r.data.comments) ? r.data.comments.filter(function (c) { return !c.parent_id; }) : [] } : { error: true };
      var box = Y.body && Y.body.querySelector('[data-yb-sigs="' + key + '"]');
      if (box) { var p = Y.pages[Y.i]; box.innerHTML = ybSigs(key, p && p.names ? p.names.join(', ') : ''); ybForms(); }
    });
  }
  function ybRecords() {
    var rec = H.records(ybStudies(), D.products);
    return '<div class="sha-yb-spread"><div class="sha-yb-page"><h2 class="sha-yb-h">Class Records</h2><p class="shx-fine">Just for fun, worked out from the yearbook itself.</p><ul class="sha-yb-rec">' +
      rec.map(function (r) { var idx = r.s ? Y.pages.map(function (p) { return p.s; }).indexOf(r.s) : -1; return '<li><span>' + esc(r.t) + '</span>' + (idx >= 0 ? '<button type="button" class="sha-link" data-yb-go="' + idx + '">' + esc(r.v) + '</button>' : '<b>' + esc(r.v) + '</b>') + '</li>'; }).join('') +
      '</ul>' + ybFoot(Y.i + 1) + '</div><div class="sha-yb-page sha-yb-side"><h2 class="sha-yb-h">Most likely to…</h2><ul class="sha-yb-rec"><li><span>…be rewatched during study period</span><b>Every episode</b></li><li><span>…end up in your locker</span><b>Anything from the Store</b></li><li><span>…get signed the most</span><b>Your pick. Go sign a page.</b></li></ul></div></div>';
  }
  function ybBack() {
    return '<div class="sha-yb-cover sha-yb-backc"><div class="sha-yb-emboss"><div class="sha-yb-c2" style="font-size:30px">Stay creative.</div><div class="sha-yb-c3">See you next study.</div></div>' +
      '<div class="sha-yb-seen"><button type="button" class="shx-btn" data-yb-go="0">Back to the cover</button><button type="button" class="shx-btn" data-yb="board">Talk about it on the Bulletin Board</button></div></div>';
  }
  function yRender() {
    var body = Y.body; if (!body) return;
    Y.pages = H.ybPages(ybStudies());
    Y.i = Math.min(Math.max(0, Y.i), Y.pages.length - 1);
    var p = Y.pages[Y.i], inner = p.k === 'cover' ? ybCover() : p.k === 'toc' ? ybToc() : p.k === 'study' ? ybStudy(p) : p.k === 'records' ? ybRecords() : ybBack();
    body.innerHTML = band('Yearbook', 'Study Hall University') +
      '<div class="sha-scroll sha-yb-desk"><div class="sha-yb-book sha-yb-is-' + p.k + (Y.dir ? ' sha-turn-' + Y.dir : '') + '" tabindex="-1">' + inner + '</div></div>' +
      '<div class="sha-yb-nav shx-raised"><button type="button" class="shx-btn" data-yb="prev"' + (Y.i ? '' : ' disabled') + ' aria-label="Previous page">◀<span class="sha-hide-s"> Prev</span></button>' +
      '<button type="button" class="shx-btn" data-yb-go="1">Contents</button><span class="sha-yb-count">Page ' + (Y.i + 1) + ' of ' + Y.pages.length + '</span>' +
      '<button type="button" class="shx-btn" data-yb="next"' + (Y.i < Y.pages.length - 1 ? '' : ' disabled') + ' aria-label="Next page"><span class="sha-hide-s">Next </span>▶</button></div>';
    Y.dir = '';
    sset('yb_page', Y.i);
    ybForms();
  }
  function ybForms() {
    Array.prototype.forEach.call(Y.body ? Y.body.querySelectorAll('form[data-yb-sign]') : [], function (f) {
      f.onsubmit = function (ev) {
        ev.preventDefault();
        var key = f.getAttribute('data-yb-sign'), tx = f.querySelector('textarea').value.trim(), st = f.querySelector('[role=status]');
        if (!tx || f.__busy) return; f.__busy = true; st.textContent = 'Signing…';
        api('/comments', { method: 'POST', body: { article: key, body: tx } }).then(function (r) {
          f.__busy = false;
          if (!r.ok) { if (needPage(r)) { f.outerHTML = pageNote(); } else st.textContent = r.data && r.data.error === 'comment' ? 'The yearbook can’t take signatures yet.' : errText(r, 'Couldn’t sign right now.'); return; }
          if (r.data && r.data.status === 'pending') { st.textContent = 'Sent to the Front Office for review.'; f.querySelector('textarea').value = ''; return; }
          delete Y.sig[key]; loadSigs(key);
        });
      };
    });
  }
  function ybGo(i, dir) { Y.dir = dir || (i > Y.i ? 'next' : 'prev'); Y.i = i; yRender(); var sc = Y.body && Y.body.querySelector('.sha-scroll'); if (sc) sc.scrollTop = 0; }
  function watch(yt) {
    var card = null;
    try { card = document.querySelector('#mediaplayer-episode-list [data-video-id="' + yt.replace(/[^A-Za-z0-9_-]/g, '') + '"]'); } catch (e) {}
    if (card && typeof window.mediaplayerWindowOpen === 'function') { try { window.mediaplayerWindowOpen(); card.click(); return; } catch (e) {} }
    window.open('https://www.youtube.com/watch?v=' + encodeURIComponent(yt), '_blank', 'noopener');
  }
  function yClick(e, t) {
    var g = t.closest('[data-yb-go]'); if (g) { ybGo(+g.getAttribute('data-yb-go')); return; }
    var b = t.closest('[data-yb]'); if (!b) return;
    var a = b.getAttribute('data-yb');
    if (a === 'next' && Y.i < Y.pages.length - 1) ybGo(Y.i + 1, 'next');
    else if (a === 'prev' && Y.i > 0) ybGo(Y.i - 1, 'prev');
    else if (a === 'watch') watch(b.getAttribute('data-yt'));
    else if (a === 'board') openApp('board');
  }
  function renderYearbook(body) {
    var first = !Y.body;
    Y.body = body; wire(body, yClick);
    if (first) {
      Y.i = Number(sget('yb_page', 0)) || 0;
      body.addEventListener('keydown', function (e) {
        if (/^(TEXTAREA|INPUT|SELECT)$/.test(e.target.tagName)) return;
        if (e.key === 'ArrowRight' && Y.i < Y.pages.length - 1) { e.preventDefault(); ybGo(Y.i + 1, 'next'); }
        else if (e.key === 'ArrowLeft' && Y.i > 0) { e.preventDefault(); ybGo(Y.i - 1, 'prev'); }
      });
      var x0 = null;
      body.addEventListener('touchstart', function (e) { if (e.touches.length === 1 && e.target.closest && e.target.closest('.sha-yb-book') && !e.target.closest('form')) x0 = [e.touches[0].clientX, e.touches[0].clientY]; else x0 = null; }, { passive: true });
      body.addEventListener('touchend', function (e) {
        if (!x0 || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - x0[0], dy = e.changedTouches[0].clientY - x0[1]; x0 = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { if (dx < 0 && Y.i < Y.pages.length - 1) ybGo(Y.i + 1, 'next'); else if (dx > 0 && Y.i > 0) ybGo(Y.i - 1, 'prev'); }
      }, { passive: true });
    }
    yRender();
  }

  // ══ 3. Honor Roll ══
  var R = { tab: 'overall', period: 'all', games: null, cache: {}, body: null };
  function rKey() { return R.tab === 'overall' ? 'overall' : R.tab + ':' + R.period; }
  function rRender() {
    var body = R.body; if (!body) return;
    var tabs = [['overall', 'Overall']].concat(R.games ? Object.keys(R.games).map(function (k) { return [k, H.shortLabel(R.games[k].label || k)]; }) : []);
    var h = band('Honor Roll', 'Top students in the Computer Lab and on the Library Card');
    h += '<div class="sha-tabs" role="tablist">' + tabs.map(function (t) { return '<button type="button" role="tab" class="sha-tab" data-hr-tab="' + esc(t[0]) + '" aria-selected="' + (R.tab === t[0]) + '">' + esc(t[1]) + '</button>'; }).join('') + '</div>';
    var g = R.games && R.games[R.tab], label = R.tab === 'overall' ? 'Library Card points, all time' : (g ? g.label : '');
    h += '<div class="sha-bar shx-raised"><span class="shx-fine"><b>' + esc(label) + '</b></span>' + (R.tab === 'overall' ? '' :
      '<span class="sha-seg"><button type="button" class="shx-btn" data-hr-p="week" aria-pressed="' + (R.period === 'week') + '">This week</button><button type="button" class="shx-btn" data-hr-p="all" aria-pressed="' + (R.period !== 'week') + '">All time</button></span>') + '</div>';
    h += '<div class="sha-scroll shx-sunken">';
    var d = R.cache[rKey()], mine = me(), myH = mine && mine.handle;
    if (!d) h += '<div class="shx-empty">Loading…</div>';
    else if (d.error) h += '<div class="shx-empty">The Honor Roll is offline right now.</div>';
    else if (!d.rows.length) h += '<div class="shx-empty">Nobody here yet. Be first.</div>';
    else {
      var onIt = false;
      h += '<table class="sha-tbl sha-hr"><thead><tr><th class="n">#</th><th>Student</th><th class="n">' + (R.tab === 'overall' ? 'Points' : 'Score') + '</th></tr></thead><tbody>';
      d.rows.slice(0, 50).forEach(function (r, i) {
        var you = myH && r.handle === myH; if (you) onIt = true;
        h += '<tr' + (you ? ' class="sha-you"' : i < 3 ? ' class="sha-top' + (i + 1) + '"' : '') + '><td class="n"><span class="sha-rk">' + (i + 1) + '</span></td><td><div class="sha-hr-who">' +
          (r.handle ? '<button type="button" class="sha-av" data-sha-profile="' + esc(r.handle) + '" aria-label="' + esc(r.display_name || r.handle) + '">' + avatar(r, 28) + '</button>' : avatar(r, 28)) +
          '<span><span>' + authorHTML(r) + (you ? ' <span class="sha-tag sha-tag-you">You</span>' : '') + '</span>' + (R.tab === 'overall' && r.rank ? '<small>' + esc(r.rank) + '</small>' : '') + '</span></div></td>' +
          '<td class="n"><b>' + esc(R.tab === 'overall' ? H.num(r.score) : H.scoreFmt(g && g.label, r.score)) + '</b></td></tr>';
      });
      h += '</tbody></table>';
      if (myH && !onIt) h += '<p class="shx-fine sha-pad">You’re not on this board yet. Keep at it.</p>';
    }
    if (!signedIn()) h += signInNote('Sign in and publish your Yearbook page to get on the Honor Roll.');
    else if (!mine) h += '<p class="shx-fine sha-pad">Only published Yearbook pages appear here. <button type="button" class="sha-link" data-sha="portal">Make my page</button></p>';
    if (R.tab !== 'overall') h += '<div class="sha-pad"><button type="button" class="shx-btn" data-hr="lab">Play in the Computer Lab</button></div>';
    h += '</div>';
    body.innerHTML = h;
    var sel = body.querySelector('.sha-tab[aria-selected="true"]'); if (sel && sel.scrollIntoView && R.scrollTab) { try { sel.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} R.scrollTab = false; }
  }
  function rLoad() {
    var key = rKey(); if (R.cache[key] && !R.cache[key].error) { rRender(); return; }
    delete R.cache[key]; rRender();
    var path = R.tab === 'overall' ? '/honor' : '/leaderboard?game=' + encodeURIComponent(R.tab) + '&period=' + (R.period === 'week' ? 'week' : 'all');
    api(path).then(function (r) { R.cache[key] = r.ok && Array.isArray(r.data.rows) ? { rows: r.data.rows } : { error: true }; if (rKey() === key) rRender(); });
  }
  function rClick(e, t) {
    var tb = t.closest('[data-hr-tab]'); if (tb) { R.tab = tb.getAttribute('data-hr-tab'); R.scrollTab = true; rLoad(); return; }
    var p = t.closest('[data-hr-p]'); if (p) { R.period = p.getAttribute('data-hr-p'); rLoad(); return; }
    if (t.closest('[data-hr="lab"]')) openApp('lab');
  }
  function renderHonor(body) {
    R.body = body; wire(body, rClick);
    if (!R.games) api('/meta').then(function (r) { R.games = r.ok && r.data.games && typeof r.data.games === 'object' ? r.data.games : {}; rRender(); });
    // refresh on every open (the server caches for 30s anyway)
    R.cache = {};
    rLoad();
  }

  // ══ 4. Store hall-pass reminder ══
  // First popup after 5 minutes on the site (tab visible), then 5 minutes after each one is
  // closed, ignored or used. Waits (never gives up) while a Lab game is being played or the
  // cart/checkout is open, then shows straight after. ?sha_remind_test=1 makes the first one
  // come after 10 seconds. Only a time counter and a mute flag are stored.
  var RM = { st: null, el: null, timer: null, hideT: null, k: 'sha_remind_v2', mem: null, test: false, why: '' };
  function rmRaw() { try { var s = window.localStorage.getItem(RM.k); return s ? JSON.parse(s) : null; } catch (e) { return undefined; } }
  function rmSave() { RM.mem = RM.st; try { window.localStorage.setItem(RM.k, JSON.stringify(RM.st)); } catch (e) {} }
  function rmLoad(test) { var raw = rmRaw(); RM.st = H.remState(raw === undefined ? RM.mem : raw, Date.now(), test); }
  function rmBlocked() {
    try {
      if (/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return 'checkout';
      var lab = $('lab-window'); if (shown(lab) && lab.querySelector('#shx-stage')) return 'game';
      if (shown($('store-cart-view')) || shown($('mobile-fullscreen-cart-view'))) return 'cart';
      var dr = document.querySelector('cart-drawer.active, .cart-drawer.is-open, #CartDrawer.active, [data-cart-open="true"]'); if (dr && shown(dr)) return 'cart';
    } catch (e) {}
    return '';
  }
  function rmProduct(n) {
    var list = (Array.isArray(D.products) ? D.products : []).filter(function (p) { return p && p.available && p.title; });
    return list.length ? list[n % list.length] : null;
  }
  function openStore() {
    try {
      var mb = $('mobile-store-open-btn');
      if (isPhone() && mb) { mb.click(); return; }
      if (typeof window.storeWindowOpen === 'function') { window.storeWindowOpen(); return; }
      var ib = $('store-icon-btn'); if (ib) { ib.click(); return; }
    } catch (e) {}
    window.location.href = (D.root || '/') + 'collections/all';
  }
  // done: true = closed/used/ignored (next one in 5 minutes); false = pulled away by a game or the cart (show again right after)
  function rmHide(done) {
    clearTimeout(RM.hideT);
    if (RM.el) { try { RM.el.parentNode.removeChild(RM.el); } catch (e) {} RM.el = null; }
    if (!RM.st) return;
    rmLoad(false);
    if (done) H.later(RM.st); else RM.st.next = RM.st.e;
    rmSave();
  }
  function rmShow() {
    if (RM.el) return;
    var phone = isPhone();
    var n = Math.floor(RM.st.e / H.REMIND_EVERY), p = phone ? null : rmProduct(n), line = H.LINES[n % H.LINES.length];
    var el = document.createElement('div');
    el.className = 'sha-bubble shx-raised' + (phone ? ' sha-toast' : ''); el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    if (!phone) {
      var tb = $('store-taskbar'), bottom = 12;
      try { if (shown(tb)) bottom = Math.max(12, window.innerHeight - tb.getBoundingClientRect().top + 10); } catch (e) {}
      el.style.bottom = bottom + 'px';
    }
    el.innerHTML = (phone ? '' : '<div class="sha-bubble-t"><span>Study Hall Store</span><button type="button" class="shx-close" data-rm="later" aria-label="Close">✕</button></div>') +
      '<div class="sha-bubble-b">' + (I.giuseppeHead ? '<img class="sha-bubble-g" src="' + esc(I.giuseppeHead) + '" alt="Giuseppe">' : '') + '<p>' + esc(line) + '</p>' +
      (phone ? '<button type="button" class="shx-close" data-rm="later" aria-label="Close">✕</button>' : '') + '</div>' +
      (p ? '<a class="sha-bubble-p" href="' + esc(p.url || '#') + '" data-shx-product="' + esc(p.id) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '<span><b>' + esc(p.title) + '</b>' + (p.price ? '<small>' + esc(p.price) + '</small>' : '') + '</span></a>' : '') +
      '<div class="sha-bubble-a"><button type="button" class="sha-link sha-bubble-m" data-rm="mute">Don’t remind me again this visit</button><button type="button" class="shx-btn shx-btn-blue" data-rm="store">Open Store</button><button type="button" class="shx-btn" data-rm="later">Later</button></div>';
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-rm],[data-shx-product]'); if (!b) return;
      var a = b.getAttribute('data-rm');
      if (a === 'store') { rmHide(true); openStore(); }
      else if (a === 'later') rmHide(true);
      else if (a === 'mute') { rmHide(true); rmLoad(false); RM.st.mute = true; rmSave(); }
      else setTimeout(function () { rmHide(true); }, 0); // product link: the campus click handler opens it
    });
    document.body.appendChild(el); RM.el = el;
    // While it is up, a page change must not bring it straight back
    H.later(RM.st); rmSave();
    RM.hideT = setTimeout(function () { rmHide(true); }, 45000);
  }
  function rmStep() {
    var vis = !document.visibilityState || document.visibilityState === 'visible';
    rmLoad(false);
    RM.st = H.tick(RM.st, vis, Date.now());
    if (RM.el && !document.body.contains(RM.el)) { RM.el = null; clearTimeout(RM.hideT); }
    var why = rmBlocked(); RM.why = why;
    if (RM.el && why) rmHide(false);
    else if (vis && H.due(RM.st, why, !!RM.el)) rmShow();
    rmSave();
  }
  function startReminder() {
    if (RM.timer) return;
    if (!document.body) { document.addEventListener('DOMContentLoaded', startReminder); return; }
    try { RM.test = /(?:^|[?&])sha_remind_test=1(?:&|$)/.test(location.search); } catch (e) {}
    rmLoad(RM.test); rmSave();
    RM.timer = setInterval(function () { try { rmStep(); } catch (e) {} }, 1000);
    window.addEventListener('pagehide', function () { try { if (RM.st) { RM.st.seen = Date.now(); rmSave(); } } catch (e) {} });
  }
  // Console helper for testing: SHApps.remind() shows the state, SHApps.remind('now') makes it due
  function rmDebug(cmd) {
    if (!RM.st) return null;
    if (cmd === 'now') { RM.st.next = RM.st.e; RM.st.mute = false; rmSave(); }
    if (cmd === 'reset') { RM.st = H.remState(null, Date.now(), false); rmSave(); }
    return { seconds: RM.st.e, nextAt: RM.st.next, inSeconds: Math.max(0, RM.st.next - RM.st.e), muted: RM.st.mute, waitingFor: RM.why || null, showing: !!RM.el };
  }

  // ── Boot ──
  var booted = false;
  function readData() {
    if (S && S.D) { D = S.D; I = S.I || D.img || {}; return; }
    try { var el = $('shx-data'); if (el) { D = JSON.parse(el.textContent) || {}; I = D.img || {}; } } catch (e) {}
  }
  function boot() {
    if (booted) return;
    S = window.SHX || null;
    if (!S) return;
    booted = true; readData();
    function reg(id, fn) { try { if (typeof S.registerApp === 'function') S.registerApp(id, function (body) { if (!body) return; try { fn(body); } catch (e) { if (window.console) console.error(e); try { body.innerHTML = '<div class="shx-empty">This window couldn’t open right now.</div>'; } catch (e2) {} } }); } catch (e) {} }
    reg('board', renderBoard); reg('yearbook', renderYearbook); reg('honor', renderHonor);
  }
  window.SHApps = { H: H, version: 2, remind: rmDebug };
  // The Store reminder runs on every page from the page data, with or without the kit
  readData(); startReminder();
  if (window.SHX) boot(); else document.addEventListener('shx:ready', boot);
})();
